module.exports = __webpack_public_path__ + "media/images/flags/iq-5cd51d2bbb7385580434ed831dbdf8ca.svg";